/*
 * IMPORTANT: Never use this mixin for server-rendered components as you will cause a hydration error.
 */

import { onMounted, ref, onUnmounted, computed } from 'vue'
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '@/tailwind.config.js'
const resolvedConfig = resolveConfig(tailwindConfig)

export default function useBreakpoint() {
  const mdBreakpoint = resolvedConfig.theme.screens.md
  const lgBreakpoint = resolvedConfig.theme.screens.lg

  const isSmBreakpointOrAbove = ref(false)
  const isMdBreakpointOrAbove = ref(false)

  const mediaQueryList = computed(() => ({
    md: window.matchMedia(`(min-width: ${mdBreakpoint})`),
    lg: window.matchMedia(`(min-width: ${lgBreakpoint})`)
  }))

  function mediaQueryListMatches () {
    isSmBreakpointOrAbove.value = mediaQueryList.value.md.matches
    isMdBreakpointOrAbove.value = mediaQueryList.value.lg.matches
  }

  onMounted(() => {
    mediaQueryListMatches()
    Object.keys(mediaQueryList.value).forEach((key) => {
      mediaQueryList.value[key].addEventListener('change', mediaQueryListMatches)
    })
  })

  onUnmounted(() => {
    Object.keys(mediaQueryList.value).forEach((key) => {
      mediaQueryList.value[key].removeEventListener('change', mediaQueryListMatches)
    })
  })

  return { isSmBreakpointOrAbove, isMdBreakpointOrAbove }
}
